// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2110":"0d276394","3165":"3a3d2645"}[chunkId] + ".chunk.css";
};